module.exports = __webpack_public_path__ + "img/pluto118.2cb0b9e6.jpg";